export default __webpack_public_path__ + "static/SR USA - Kosher - Certificate-c73e850094a90e5e6d0f49afaab5045c.pdf";